import { Tab, Tabs } from "@mui/material";
import { styled } from "@mui/material/styles";

function BasicTabs({ tabs, status, setStatus }) {
  const StyledTabs = styled(Tabs)({
    backgroundColor:"inherit",
    "& .MuiTabs-indicator": {
      backgroundColor: "transparent",
      boxShadow: "none",
    },
  });

  const StyledTab = styled(Tab)({
    "&:hover": {
      borderBottom: "4px solid #1A73E8",
    },
    backgroundColor: "lavender",
    borderRadius: 0,
    marginLeft: ".5rem",
    //borderLeft:"1px solid black",
    "&.Mui-selected": {
      fontWeight: "bold",
      borderBottom: "4px solid #1A73E8",
      backgroundColor: "lavender",
    },
  });
  return (
    <StyledTabs sx={{ padding:".1rem"  }} value={status} onChange={(e, v) => setStatus(v)}>
      {tabs.map((tab, index) => (
        <StyledTab
          key={index}
          sx={{ margin: "0 10px 0 0", border: "1px solid lightblue" }}
          value={tab}
          label={tab}
        />
      ))}
    </StyledTabs>
  );
}

export default BasicTabs;
